import {
  HttpEvent, HttpHandler, HttpHandlerFn, HttpInterceptor, HttpInterceptorFn, HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { PublicUrlService } from './publicuri.service';
import { TokenService } from './token.service';

const allowedUrls = [environment.apiBioUrl, environment.apiDocUrl, environment.apiUrl];

@Injectable({providedIn: 'root'})
export class RoleInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private publicUrlService: PublicUrlService
) {}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url?.toLowerCase() ?? req.url;

    if (this.publicUrlService.isPublic(url) && !this.tokenService.hasValidToken()) {
      console.log('🔓 Public request, skipping token injection');
      return next.handle(req);
    }

    const token = this.tokenService.getToken();

    if (!token) {
      console.warn('🔐 No token available, forwarding request without token');
      return next.handle(req);
    }

    const authReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });

    return next.handle(authReq);
  }
}

export const roleInterceptor: HttpInterceptorFn = (req: HttpRequest<any>,next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authService = inject(OAuthService);
  const token = localStorage.getItem('access_token'); // implement this in your AuthService

  const isPublic = req.url?.startsWith(environment.keycloakHost)
  if (isPublic) {
    console.log(`KC REQ - ${token? 'w/TOKEN':'w/oTOKEN'}`);
    if(!token) {
      return next(req); // skip token injection
    }
  }

  const authReq = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;
  return next(authReq);
};

